import { Component, Input } from '@angular/core';

@Component({
  selector: 'rsc-asp-button',
  standalone: true,
  imports: [],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  @Input() buttonLabel: string;
  @Input() redirectUrl: string;
  @Input() openInNewTab: boolean;

  constructor() {
    this.buttonLabel = '';
    this.redirectUrl = '';
    this.openInNewTab = false;
  }

  navigate(): void {
    if (this.openInNewTab) {
      window.open(this.redirectUrl, '_blank');
    } else {
      window.location.href = this.redirectUrl;
    }
  }
}
